<template>
  <div>
    <Loading :center="false" v-show="loading" />
    <div v-show="!loading">
      <div class="danger-zone">
        <i class="fa-sharp fa-solid fa-triangle-exclamation"></i> Zona de Perigo
      </div>
      <Molded>
        <b-row>
          <b-col sm="12">
            <RadioGroup title="Controlar por Patrimônio?" field="manageByPatrimony" :formName="formName" :options="[
              { text: 'Sim', value: true },
              { text: 'Não', value: false },
            ]" v-model="parameterDangerZone.manageByPatrimony" />
            <Alert type="danger">
              <span>
                Atenção, tenha certeza da alteração, isso pode causar
                divergência de estoque!
              </span>
            </Alert>
            <Alert type="warning">
              <span>
                Os produtos que já estão cadastrados não serão alterados!
              </span>
            </Alert>
          </b-col>
        </b-row>
      </Molded>
      <br />
      <Molded>
        <b-row>
          <b-col sm="12">
            <RadioGroup title="Calcular Período" field="CalculateByFullPeriod" :formName="formName" :options="[
              { text: 'Dia - Horário Comercial', value: false },
              { text: 'Dia - 24 horas', value: true },
            ]" v-model="parameterDangerZone.calculateByFullPeriod" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <CheckboxGroup title="Display (Calculo de Período)" field="displayPeriod"
              :options="optionsDisplayByFullPeriod" :initialValue="parameterDangerZone.displayPeriod"
              v-model="parameterDangerZone.displayPeriod" />
          </b-col>
        </b-row>
      </Molded>
    </div>
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";
import CheckboxGroup from "@nixweb/nixloc-ui/src/component/forms/CheckboxGroup";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import ParameterDangerZone from "@/components/modules/adm/parameter/ParameterDangerZone.js";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    Molded,
    Loading,
    RadioGroup,
    CheckboxGroup,
    Alert,
  },
  name: "ParameterDangerZone",
  data() {
    return {
      formName: "updateParameterDangerZone",
      parameterDangerZone: new ParameterDangerZone(),
      urlUpdate: "/api/v1/adm/parameter-danger-zone/update",
      urlGetById: "/api/v1/adm/parameter-danger-zone/get-by-companyid",
      loading: true,
      options: [
        { text: "Minuto", value: "1" },
        { text: "Hora", value: "2" },
        { text: "Dia", value: "3", disabled: true },
        { text: "Semana", value: "4" },
        { text: "Quinzena", value: "5" },
        { text: "Mês", value: "6", disabled: true },
        { text: "Ano", value: "7", disabled: true },
      ],
    };
  },
  created() {
    this.getById();
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event", "isLoading"]),
    ...mapGetters("user", ["hasModule"]),
    ...mapState("user", ["userLogged"]),
    optionsDisplayByFullPeriod() {
      let calculateByFullPeriod =
        this.parameterDangerZone.calculateByFullPeriod;
      let display = [];

      this.options.forEach((item) => {
        if (!calculateByFullPeriod && item.value == "1") return;
        if (!calculateByFullPeriod && item.value == "2") return;
        display.push(item);
      });

      return display;
    },
  },
  methods: {
    ...mapActions("generic", ["putApi", "getApi"]),
    ...mapMutations("generic", ["addLoading", "removeLoading", "addEvent"]),
    ...mapMutations("validation", ["resetValidation", "updateFormDirty"]),
    ...mapMutations("user", ["updateParameterDangerZone"]),
    getById() {
      this.addLoading(["parameterDangerZone"]);
      let params = { url: this.urlGetById, id: this.id };
      this.getApi(params).then((response) => {
        this.parameterDangerZone.update(response.content);
        let self = this;
        setTimeout(function () {
          self.updateFormDirty(false);
          self.loading = false;
          self.removeLoading(["parameterDangerZone"]);
        }, 350);
      });
    },
    update() {
      let params = { url: this.urlUpdate, obj: this.parameterDangerZone };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.updateParameterDangerZone(this.parameterDangerZone);
          this.addEvent({ name: "renovateToken" });
        }
        this.removeLoading(["saveSaveCancel"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "saveSaveCancel") {
          this.update();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.danger-zone {
  font-size: 18px;
  color: red;
  margin-left: 5px;
  margin-bottom: 10px;
}
</style>